// extracted by mini-css-extract-plugin
module.exports = {"rentalInfoWrapper":"AI","status":"AJ","timeLeft":"AK"};